import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { TagSize, TagTypes } from '@/enums/tag-enums';
import TagList from '@/components/TagList/TagList.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SSPolicyDiscounts',
  props: {
    summaryHeading: {},
    showOnlineDiscount: { type: Boolean },
    showOnlineDiscountLast: { type: Boolean },
    noBorder: { type: Boolean },
    noPadding: { type: Boolean },
    discounts: {},
    tagSize: {}
  },
  setup(__props: any) {

const { getLocaleMessage } = useI18n();
const dictionary: Record<string, string> = getLocaleMessage('en') as any;

const props = __props;

const discounts = computed(() => {
  let discounts = [] as string[];
  props.discounts.forEach((value: string) => {
    discounts.push(dictionary[value]);
  });
  return discounts;
});

return (_ctx: any,_cache: any) => {
  return (discounts.value?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.noBorder ? '' : 'border-b')
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.noPadding ? '' : 'px-5 md:px-8 pt-2 md:pb-8 sm:pb-8')
        }, [
          (_ctx.summaryHeading)
            ? (_openBlock(), _createElementBlock("h5", {
                key: 0,
                class: _normalizeClass([_ctx.noPadding ? '' : 'pt-5', "text-lg-bold title pb-2 text-racq-dark-grey"])
              }, _toDisplayString(_ctx.summaryHeading), 3))
            : _createCommentVNode("", true),
          _createVNode(TagList, {
            tags: discounts.value,
            tagType: _unref(TagTypes).discount,
            tagSize: _ctx.tagSize
          }, null, 8, ["tags", "tagType", "tagSize"])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})